import React from 'react';
import ReactDOM from 'react-dom';

class Modal extends React.Component {
    modalRoot = document.getElementById('modal-root');
    el: HTMLDivElement;
    constructor(props: Readonly<{}>) {
        super(props);
        this.el = document.createElement('div');
    }

    componentDidMount() {
        if (this.modalRoot) this.modalRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        if (this.modalRoot) this.modalRoot.removeChild(this.el);
    }

    render() {
        return ReactDOM.createPortal(this.props.children, this.el);
    }
}

export default Modal;
